import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vouch_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  loginUrl: async () => (await api.get("/auth/facebook/login")).data,
  me: async () => (await api.get("/auth/me")).data,
  logout: () => {
    localStorage.removeItem("vouch_token");
    window.location.href = "/";
  },
};

export const data = {
  myCategorized: async (refresh = false) =>
    (await api.get(`/me/categorized${refresh ? "?refresh=true" : ""}`)).data,
  myFriends: async () => (await api.get("/me/friends")).data,
  users: async () => (await api.get("/users")).data,
  userCategorized: async (id) =>
    (await api.get(`/users/${id}/categorized`)).data,
};
